<template>

    <v-dialog width="auto" style="max-height: 90vh">
        <template v-slot:activator="{ props }">
            <v-btn v-bind="props" prepend-icon="mdi-key" size="default" class="mb-4" color="blue-darken-3"
                @click="">
                dispositivi connessi
            </v-btn>
        </template>

        <template v-slot:default="{ isActive }">
            <v-card theme="dark">
                <v-card-item>
                    <v-card-title>Dispositivi connessi</v-card-title>
                </v-card-item>
                <v-card-text>
                    <p>
                        Puoi controllare i dispositivi autenticati e disconnetterli se necessario.<br>
                        Il cambio password non disconnette i dispositivi collegati.
                    </p>
                    <v-list density="compact" style="overflow-y: auto" lines="" variant="flat">
                        <v-list-item v-for="(token, i) in tokens" :key="i">
                            <template v-slot:prepend class="align-start">
                                <template v-if="isCurrent(token)">
                                    <v-btn icon class="mr-6" color="primary" :rounded="'lg'"  > 
                                        <v-icon class="ma-2">mdi-cog mdi-spin</v-icon>
                                    </v-btn>
                                </template>
                                <template v-else>

                                    <v-dialog width="auto" style="max-height: 90vh">
                                        <template v-slot:activator="{ props }">
                                            <v-btn v-bind="props" 
                                            icon   class="mr-6" color="red-darken-3"  :rounded="'lg'">
                                                <v-icon class="ma-2">mdi-link-off</v-icon>
                                            </v-btn>
                                        </template>
                                        <template v-slot:default="{ isActive }">
                                            <v-card theme="dark">
                                                <v-card-item>
                                                    <v-card-title>Disconnessione dispositivo</v-card-title>
                                                    <v-card-subtitle>{{ token.partialkey.substring(0, 5) }}{{ "*".repeat(15) }}</v-card-subtitle>
                                                </v-card-item>
                                                <v-card-text>

                                                    Stai per disconnettere il dispositivo<br>
                                                    <strong>{{ token.device_description || "Senza nome" }}</strong><br>
                                                    ultimo utilizzo: {{ new Date(token?.last_used).toLocaleString() }}


                                                </v-card-text>

                                                <v-card-actions class="d-flex flex-column align-center ">
                                                    <v-btn variant="flat" size="large" color="red-darken-2"
                                                        class="my-1 mx-0" @click="disconnect(token) ; isActive.value = false;">
                                                        <v-icon color="" class="mr-2">mdi-link-off</v-icon>
                                                        Disconnetti</v-btn>
                                                    <v-btn variant="outlined" size="large" color="white"
                                                        class="my-1 mx-0" @click="isActive.value = false;">
                                                        <v-icon class="mr-2">mdi-chevron-down</v-icon>
                                                        Indietro</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </template>
                                    </v-dialog>

                                </template>
                            </template>
                            <template v-slot:title>
                                <v-icon class="mr-2">{{ iconFor(token) }}</v-icon>
                                <span  v-if="isCurrent(token)">
                                Attualmente in uso
                            </span>
                            <span  v-else>
                                {{ token.device_description || "Dispositivo ignoto" }}<br>
                            </span>
                            </template>
                            <template v-slot:subtitle class="mt-2">
                                <v-icon class="mr-2">mdi-clock-time-four-outline</v-icon>{{ new
                                    Date(token?.last_used).toLocaleString() }}
                            </template>
                            

                        </v-list-item>
                    </v-list>

                    <p>
                        I dispositivi vengono disconnessi automaticamente, dopo un periodo di inattività (60 giorni).
                    </p>

                </v-card-text>
                <v-card-actions class="d-flex flex-column align-center ">
                    <v-btn variant="outlined" size="large" color="white" class="my-1 mx-0"
                        @click="isActive.value = false;">
                        <v-icon class="mr-2">mdi-chevron-down</v-icon>
                        Indietro</v-btn>
                </v-card-actions>
            </v-card>
        </template>
    </v-dialog>

</template>

<script setup>


import { ref, onMounted } from "vue"
import { useApi } from "@/service/api"
import { useRuntimeStore } from "@/store/runtime"
import { useToastsStore } from "@/store/toasts";

const api = useApi()
const runtimeStore = useRuntimeStore();
const toastsStore = useToastsStore();

const tokens = ref([])

const isCurrent = (token) => {
    if (runtimeStore.session.user?.token.substring(0, 10) === token.partialkey) {
        return true
    }
    return false
}

onMounted(() => {
    loadTokens()
})


const disconnect = async (token) => {

    const deleteResult = await api.tracker.deleteAuthToken({ partialkey: token.partialkey })

    console.log(deleteResult)

    let the_text = `Errore durante il tentativo di disconnessione del dispositivo.`
    let the_type = 'warning'
    let the_duration = 10000

    if (deleteResult.response === undefined) {
        // errore di rete
        the_text = `Non è stato possibile disconnettere il dispositivo,
        riprovare in seguito.`
        the_type = 'warning'
        the_duration = 10000
    }
    else {
        if (deleteResult.response.status >= 200 && deleteResult.response.status < 300) {
            the_text = `Dispositivo disconnesso con successo.`
            the_type = 'success'
            the_duration = 5000
        }
    }
    toastsStore.toast({
            title: 'Dispositivi connessi',
            text: the_text,
            type: the_type,
            showUICountdown: true,
            duration: the_duration,
        })

    loadTokens()
}

const iconFor = (token) => {
    let icon = "mdi-cellphone"

    if (token?.device_description?.includes("Windows")) {
        icon = "mdi-microsoft-windows"
    } else if (token?.device_description?.includes("Linux")) {
        icon = "mdi-linux"
    } else if (token?.device_description?.includes("Mac")) {
        icon = "mdi-apple"
    } else if (token?.device_description?.includes("Android")) {
        icon = "mdi-cellphone"
    } else if (token?.device_description?.includes("iPhone")) {
        icon = "mdi-cellphone"
    }

    return icon
}

const loadTokens = async () => {
    const result = await api.tracker.getUserMultiTokens()
    tokens.value = result?.data?.tokens

    console.log(tokens.value)
}

</script>
